import React, { useState } from 'react';
import PropTypes from 'prop-types';
import StepIndicator from './StepIndicator'; // Import shared component
import './Step1Component.css';

// Define the simplified package details for Step 1
const Step1PackageDetails = () => (
  <div className="package-details-card step1-package-details"> {/* Added specific class */}
    <div className="details-left">
      <h4 className="package-title">Your Fably Package Includes:</h4>
      <ul>
        <li>
          <span className="icon">✨</span>
          1 Animation in Style of your choosing {/* Modified text */}
        </li>
        <li>
          <span className="icon">⏱️</span>
          Delivered within 45-55 minutes
        </li>
        <li>
          <span className="icon">✉️</span>
          Sent directly to your email
        </li>
      </ul>
    </div>
    {/* No details-right section for price */}
  </div>
);

const Step1Component = ({ onDataChange, onNext, currentStep, completedSteps }) => {
  const [textPrompt, setTextPrompt] = useState('');
  const [isValid, setIsValid] = useState(false);

  const validate = (text) => {
    const textRegex = /^[a-zA-Z0-9\s]+$/;
    return text.length > 0 && textRegex.test(text);
  };

  const handleDataUpdate = (text) => {
    const currentIsValid = validate(text);
    setIsValid(currentIsValid);
    if (currentIsValid) {
      onDataChange({ type: 'text', value: text });
    } else {
      onDataChange({ type: 'none', value: null });
    }
  };

  const handleTextInputChange = (e) => {
    const newText = e.target.value;
    setTextPrompt(newText);
    handleDataUpdate(newText);
  };

  return (
    <div>
      {/* Wrap Indicator and Title */}
      <div className="card__header">
        <h2 className="card__title">Choose your story</h2>
        <StepIndicator currentStep={currentStep} completedSteps={completedSteps} />
      </div>
      
      <div className="card__content">
        <p className="step1-instruction">Enter a book title:</p>

        <div className="card__form">
          <div className="input-wrapper">
              <span className="input-icon">📖</span>
              <input
                type="text"
                className="text-input"
                placeholder="Enter title "
                value={textPrompt}
                onChange={handleTextInputChange}
                aria-label="Book Title or Topic"
              />
          </div>
          <Step1PackageDetails />
        </div>
      </div>

      <div className="nav-area single-button">
        <button 
          className={`card__button next-button ${!isValid ? 'disabled' : ''}`}
          onClick={onNext} 
          disabled={!isValid}
        > 
          Next
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="button-arrow">
              <path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"/>
          </svg>
        </button>
      </div>

    </div>
  );
};

Step1Component.propTypes = {
  onDataChange: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  currentStep: PropTypes.number.isRequired,
  completedSteps: PropTypes.number.isRequired,
};

export default Step1Component; 